/**
 * 完成反馈组件 - 稳定布局
 * 简化结构，固定高度
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface CompletionFeedbackProps {
  allCompleted: boolean;
  tomorrowPreview?: string;
  className?: string;
}

export function CompletionFeedback({
  allCompleted,
  tomorrowPreview,
  className,
}: CompletionFeedbackProps) {
  const { t } = useTranslation("assessments");

  if (!allCompleted && !tomorrowPreview) {
    return null;
  }

  return (
    <div className={className}>
      {/* 完成提示 */}
      {allCompleted && (
        <div className="border-t bg-emerald-50/50 dark:bg-emerald-950/20 px-5 py-3.5">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center shrink-0">
              <CheckCircle2 className="h-4 w-4 text-white" strokeWidth={2.5} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-emerald-900 dark:text-emerald-100 text-sm">
                {t("dailyDashboard.allCompleted", "今日任务达成！")}
              </p>
              <p className="text-xs text-emerald-700/80 dark:text-emerald-300/80">
                {t("dailyDashboard.keepItUp", "继续保持！")}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* 明日预告 */}
      {tomorrowPreview && (
        <button className="w-full group border-t bg-muted/10 hover:bg-muted/20 px-5 py-3 text-left transition-colors">
          <div className="flex items-center justify-between gap-3">
            <div className="flex-1 min-w-0">
              <p className="text-[10px] text-muted-foreground/50 font-medium uppercase tracking-wider mb-0.5">
                {t("dailyDashboard.tomorrowPreview", "Tomorrow")}
              </p>
              <p className="text-xs text-foreground/70 group-hover:text-foreground transition-colors truncate">
                {tomorrowPreview}
              </p>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground/40 group-hover:text-muted-foreground transition-colors shrink-0" />
          </div>
        </button>
      )}
    </div>
  );
}

export default CompletionFeedback;
